import { createFileRoute } from "@tanstack/react-router";
import { requireReachableRoute } from "@/lib/offline/routeGuard";

// Section layout guard: marketplace is online-only by design (multi-party,
// transactional). Covers every child route via ancestor stance resolution.
export const Route = createFileRoute("/_auth/app/_app/org/$orgId/marketplace")({
	staticData: { offline: "online-only" },
	beforeLoad: () => requireReachableRoute("online-only"),
});
